module.exports = __webpack_public_path__ + "static/media/airless_spray.c1005107.svg";